<template>
    <div v-if="model" class="ml-3 mr-3">
        <h5 class="text-center mb-4">HEALTH CARE PROVIDER</h5>
        <div class="form-row mb-2">
            <label class="col-3">Name</label>         
            <input type="text" class="form-control col" placeholder="Name" v-model="model.name" />
        </div>
        <div class="form-row mb-2">
            <label class="col-3">Street or Box</label>             
         <input type="text" class="form-control col" placeholder="Street or Box" v-model="model.address" />
        </div>
        <div class="form-row mb-2">
            <label class="col-3">City</label> 
            <input type="text" class="form-control col" placeholder="City" v-model="model.city" />
        </div>
        <div class="form-row mb-2">
            <label class="col-3">State</label> 
            <select id="patient_state" class="custom-select col" v-model="model.state">
                <option v-for="state in states" :key="state.code" :value="state.code" v-text="state.name"></option>
            </select>
        </div>
        <div class="form-row mb-2">
            <label class="col-3">Zip</label> 
            <input type="text" class="form-control col" placeholder="Postal Code" v-model="model.postalCode" />
        </div>
        <div class="form-row mb-2">
            <label class="col-3">Phone</label>       
            <telephone-input class="form-control col" placeholder="Phone" v-model="model.telephone"></telephone-input>
        </div>
        <div class="form-row mb-2">
            <label class="col-3">Worx Fax</label> 
            <telephone-input class="form-control col" placeholder="Fax" v-model="model.fax" readonly></telephone-input>
        </div>  
    </div>
</template>

<script>
export default {
    props: {
        model: Object,
        states: Array,
    }
}
</script>

<style>

</style>